module.exports = new __parcel__URL__("renewableenergy.76863f77.png").toString();